export default __webpack_public_path__ + "static/media/putra-husada.cb8aadca.webp";